/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/array-type, @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types, @typescript-eslint/consistent-indexed-object-style, @typescript-eslint/no-redundant-type-constituents */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import type * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SendFeedbackEmailMutationVariables = Types.Exact<{
  input: Types.SendFeedbackEmailInput;
}>;


export type SendFeedbackEmailMutation = { __typename?: 'Mutation', sendFeedbackEmail: boolean };

export type GetUserNotificationPreferencesQueryVariables = Types.Exact<{
  input: Types.GetUserNotificationsInput;
}>;


export type GetUserNotificationPreferencesQuery = { __typename?: 'Query', getUserNotificationPreferences: Array<{ __typename?: 'NotificationSetting', identifier: string, category: string, name: string, description: string, preference: { __typename?: 'UserNotificationPreference', user_id: string, identifier: string, email_enabled: boolean } }> };

export type GetUserNotificationConnectionsQueryVariables = Types.Exact<{
  input: Types.GetUserNotificationsInput;
}>;


export type GetUserNotificationConnectionsQuery = { __typename?: 'Query', getUserNotificationConnections: { __typename?: 'GetUserNotificationConnectionsResponse', connections: Array<{ __typename?: 'UserNotificationConnection', user_id: string, email_enabled: boolean, connected_user_id: string }> } };

export type UpdateUserNotificationPreferenceMutationVariables = Types.Exact<{
  input: Types.UpdateNotificationPreferenceInput;
}>;


export type UpdateUserNotificationPreferenceMutation = { __typename?: 'Mutation', updateUserNotificationPreference: { __typename?: 'UserNotificationPreference', user_id: string, identifier: string, email_enabled: boolean } };

export type UpdateUserNotificationConnectionMutationVariables = Types.Exact<{
  input: Types.UpdateNotificationConnectionInput;
}>;


export type UpdateUserNotificationConnectionMutation = { __typename?: 'Mutation', updateUserNotificationConnection: { __typename?: 'UserNotificationConnection', user_id: string, email_enabled: boolean, connected_user_id: string } };

export type SendDisableUserEmailMutationVariables = Types.Exact<{
  input: Types.SendDisableEnableUserEmailInput;
}>;


export type SendDisableUserEmailMutation = { __typename?: 'Mutation', sendDisableUserEmail: boolean };

export type SendEnableUserEmailMutationVariables = Types.Exact<{
  input: Types.SendEnableUserEmailInput;
}>;


export type SendEnableUserEmailMutation = { __typename?: 'Mutation', sendEnableUserEmail: boolean };


export const SendFeedbackEmailDocument = gql`
    mutation sendFeedbackEmail($input: SendFeedbackEmailInput!) {
  sendFeedbackEmail(input: $input)
}
    `;
export type SendFeedbackEmailMutationFn = Apollo.MutationFunction<SendFeedbackEmailMutation, SendFeedbackEmailMutationVariables>;
export function useSendFeedbackEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendFeedbackEmailMutation, SendFeedbackEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFeedbackEmailMutation, SendFeedbackEmailMutationVariables>(SendFeedbackEmailDocument, options);
      }
export type SendFeedbackEmailMutationHookResult = ReturnType<typeof useSendFeedbackEmailMutation>;
export type SendFeedbackEmailMutationResult = Apollo.MutationResult<SendFeedbackEmailMutation>;
export type SendFeedbackEmailMutationOptions = Apollo.BaseMutationOptions<SendFeedbackEmailMutation, SendFeedbackEmailMutationVariables>;
export const GetUserNotificationPreferencesDocument = gql`
    query getUserNotificationPreferences($input: GetUserNotificationsInput!) {
  getUserNotificationPreferences(input: $input) {
    identifier
    category
    name
    description
    preference {
      user_id
      identifier
      email_enabled
    }
  }
}
    `;
export function useGetUserNotificationPreferencesQuery(baseOptions: Apollo.QueryHookOptions<GetUserNotificationPreferencesQuery, GetUserNotificationPreferencesQueryVariables> & ({ variables: GetUserNotificationPreferencesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationPreferencesQuery, GetUserNotificationPreferencesQueryVariables>(GetUserNotificationPreferencesDocument, options);
      }
export function useGetUserNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationPreferencesQuery, GetUserNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationPreferencesQuery, GetUserNotificationPreferencesQueryVariables>(GetUserNotificationPreferencesDocument, options);
        }
// @ts-ignore
export function useGetUserNotificationPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserNotificationPreferencesQuery, GetUserNotificationPreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserNotificationPreferencesQuery, GetUserNotificationPreferencesQueryVariables>;
export function useGetUserNotificationPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationPreferencesQuery, GetUserNotificationPreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserNotificationPreferencesQuery | undefined, GetUserNotificationPreferencesQueryVariables>;
export function useGetUserNotificationPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationPreferencesQuery, GetUserNotificationPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserNotificationPreferencesQuery, GetUserNotificationPreferencesQueryVariables>(GetUserNotificationPreferencesDocument, options);
        }
export type GetUserNotificationPreferencesQueryHookResult = ReturnType<typeof useGetUserNotificationPreferencesQuery>;
export type GetUserNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useGetUserNotificationPreferencesLazyQuery>;
export type GetUserNotificationPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetUserNotificationPreferencesSuspenseQuery>;
export type GetUserNotificationPreferencesQueryResult = Apollo.QueryResult<GetUserNotificationPreferencesQuery, GetUserNotificationPreferencesQueryVariables>;
export const GetUserNotificationConnectionsDocument = gql`
    query getUserNotificationConnections($input: GetUserNotificationsInput!) {
  getUserNotificationConnections(input: $input) {
    connections {
      user_id
      email_enabled
      connected_user_id
    }
  }
}
    `;
export function useGetUserNotificationConnectionsQuery(baseOptions: Apollo.QueryHookOptions<GetUserNotificationConnectionsQuery, GetUserNotificationConnectionsQueryVariables> & ({ variables: GetUserNotificationConnectionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserNotificationConnectionsQuery, GetUserNotificationConnectionsQueryVariables>(GetUserNotificationConnectionsDocument, options);
      }
export function useGetUserNotificationConnectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserNotificationConnectionsQuery, GetUserNotificationConnectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserNotificationConnectionsQuery, GetUserNotificationConnectionsQueryVariables>(GetUserNotificationConnectionsDocument, options);
        }
// @ts-ignore
export function useGetUserNotificationConnectionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserNotificationConnectionsQuery, GetUserNotificationConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserNotificationConnectionsQuery, GetUserNotificationConnectionsQueryVariables>;
export function useGetUserNotificationConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationConnectionsQuery, GetUserNotificationConnectionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserNotificationConnectionsQuery | undefined, GetUserNotificationConnectionsQueryVariables>;
export function useGetUserNotificationConnectionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserNotificationConnectionsQuery, GetUserNotificationConnectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserNotificationConnectionsQuery, GetUserNotificationConnectionsQueryVariables>(GetUserNotificationConnectionsDocument, options);
        }
export type GetUserNotificationConnectionsQueryHookResult = ReturnType<typeof useGetUserNotificationConnectionsQuery>;
export type GetUserNotificationConnectionsLazyQueryHookResult = ReturnType<typeof useGetUserNotificationConnectionsLazyQuery>;
export type GetUserNotificationConnectionsSuspenseQueryHookResult = ReturnType<typeof useGetUserNotificationConnectionsSuspenseQuery>;
export type GetUserNotificationConnectionsQueryResult = Apollo.QueryResult<GetUserNotificationConnectionsQuery, GetUserNotificationConnectionsQueryVariables>;
export const UpdateUserNotificationPreferenceDocument = gql`
    mutation updateUserNotificationPreference($input: UpdateNotificationPreferenceInput!) {
  updateUserNotificationPreference(input: $input) {
    user_id
    identifier
    email_enabled
  }
}
    `;
export type UpdateUserNotificationPreferenceMutationFn = Apollo.MutationFunction<UpdateUserNotificationPreferenceMutation, UpdateUserNotificationPreferenceMutationVariables>;
export function useUpdateUserNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNotificationPreferenceMutation, UpdateUserNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNotificationPreferenceMutation, UpdateUserNotificationPreferenceMutationVariables>(UpdateUserNotificationPreferenceDocument, options);
      }
export type UpdateUserNotificationPreferenceMutationHookResult = ReturnType<typeof useUpdateUserNotificationPreferenceMutation>;
export type UpdateUserNotificationPreferenceMutationResult = Apollo.MutationResult<UpdateUserNotificationPreferenceMutation>;
export type UpdateUserNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateUserNotificationPreferenceMutation, UpdateUserNotificationPreferenceMutationVariables>;
export const UpdateUserNotificationConnectionDocument = gql`
    mutation updateUserNotificationConnection($input: UpdateNotificationConnectionInput!) {
  updateUserNotificationConnection(input: $input) {
    user_id
    email_enabled
    connected_user_id
  }
}
    `;
export type UpdateUserNotificationConnectionMutationFn = Apollo.MutationFunction<UpdateUserNotificationConnectionMutation, UpdateUserNotificationConnectionMutationVariables>;
export function useUpdateUserNotificationConnectionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserNotificationConnectionMutation, UpdateUserNotificationConnectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserNotificationConnectionMutation, UpdateUserNotificationConnectionMutationVariables>(UpdateUserNotificationConnectionDocument, options);
      }
export type UpdateUserNotificationConnectionMutationHookResult = ReturnType<typeof useUpdateUserNotificationConnectionMutation>;
export type UpdateUserNotificationConnectionMutationResult = Apollo.MutationResult<UpdateUserNotificationConnectionMutation>;
export type UpdateUserNotificationConnectionMutationOptions = Apollo.BaseMutationOptions<UpdateUserNotificationConnectionMutation, UpdateUserNotificationConnectionMutationVariables>;
export const SendDisableUserEmailDocument = gql`
    mutation sendDisableUserEmail($input: SendDisableEnableUserEmailInput!) {
  sendDisableUserEmail(input: $input)
}
    `;
export type SendDisableUserEmailMutationFn = Apollo.MutationFunction<SendDisableUserEmailMutation, SendDisableUserEmailMutationVariables>;
export function useSendDisableUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendDisableUserEmailMutation, SendDisableUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDisableUserEmailMutation, SendDisableUserEmailMutationVariables>(SendDisableUserEmailDocument, options);
      }
export type SendDisableUserEmailMutationHookResult = ReturnType<typeof useSendDisableUserEmailMutation>;
export type SendDisableUserEmailMutationResult = Apollo.MutationResult<SendDisableUserEmailMutation>;
export type SendDisableUserEmailMutationOptions = Apollo.BaseMutationOptions<SendDisableUserEmailMutation, SendDisableUserEmailMutationVariables>;
export const SendEnableUserEmailDocument = gql`
    mutation sendEnableUserEmail($input: SendEnableUserEmailInput!) {
  sendEnableUserEmail(input: $input)
}
    `;
export type SendEnableUserEmailMutationFn = Apollo.MutationFunction<SendEnableUserEmailMutation, SendEnableUserEmailMutationVariables>;
export function useSendEnableUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendEnableUserEmailMutation, SendEnableUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEnableUserEmailMutation, SendEnableUserEmailMutationVariables>(SendEnableUserEmailDocument, options);
      }
export type SendEnableUserEmailMutationHookResult = ReturnType<typeof useSendEnableUserEmailMutation>;
export type SendEnableUserEmailMutationResult = Apollo.MutationResult<SendEnableUserEmailMutation>;
export type SendEnableUserEmailMutationOptions = Apollo.BaseMutationOptions<SendEnableUserEmailMutation, SendEnableUserEmailMutationVariables>;
import { withMutationResponseHandler, withQueryResponseHandler } from '../hooks/useResponseHandler';
export const useGetUserNotificationPreferences = withQueryResponseHandler(useGetUserNotificationPreferencesQuery);
export const useGetUserNotificationConnections = withQueryResponseHandler(useGetUserNotificationConnectionsQuery);
export const useSendFeedbackEmail = withMutationResponseHandler(useSendFeedbackEmailMutation, "sendFeedbackEmail");
export const useUpdateUserNotificationPreference = withMutationResponseHandler(useUpdateUserNotificationPreferenceMutation, "updateUserNotificationPreference");
export const useUpdateUserNotificationConnection = withMutationResponseHandler(useUpdateUserNotificationConnectionMutation, "updateUserNotificationConnection");
export const useSendDisableUserEmail = withMutationResponseHandler(useSendDisableUserEmailMutation, "sendDisableUserEmail");
export const useSendEnableUserEmail = withMutationResponseHandler(useSendEnableUserEmailMutation, "sendEnableUserEmail");